<template>
    <div id="app">
        <comHeader class="comHeader" v-if="!(name === '404' || name === 'login' || name === 'register')"></comHeader>
        <router-view class="con"/>
        <comFooter class="comHeader" v-if="!(name === '404')"></comFooter>

    </div>
</template>

<script>
import comHeader from './components/comHeader.vue'
import comFooter from './components/comFooter.vue'

export default {
    name: 'App',
    components: {
        comHeader,
        comFooter,
    },
    data() {
        return {
        Height: 0,
        isRouterAlive: true,
        name:'',
        };
    },
    watch:{
    $route(to,from){
      this.name = to.name;
    }
  },

}
</script>

<style>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    
}
*{
    margin: 0;
    padding: 0;
}
ul li{
    list-style: none;
}
body,html{
    width: 100%;
    height: 100%;
}
.comHeader{
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 999;
    text-align: center;
    border-bottom: 1px solid #eee;;
}
.con{
    /* border: 1px solid #eee; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue